import { render, staticRenderFns } from "./videopage.vue?vue&type=template&id=d724764a&scoped=true"
import script from "./videopage.vue?vue&type=script&lang=js"
export * from "./videopage.vue?vue&type=script&lang=js"
import style0 from "./videopage.vue?vue&type=style&index=0&id=d724764a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d724764a",
  null
  
)

export default component.exports